import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="flex items-center gap-1 hover:text-primary-600 transition-colors">
        <i className="ri-home-4-line"></i> 首页
      </Link>
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}